<template>
  <main>
    <div class="container">
      <div class="row py-3 py-sm-5">
        <div class="col-12">
          <h1 class="text-white text-center">
            Create your Food Fitness First, Inc.® Account
          </h1>
        </div>
      </div>
    </div>

    <!-- healthcare -->

    <div class="container-fluid bg-white-trans py-3 mb-3 mb-sm-5">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h1 class="text-bold mb-4 text-center">
              Health Care Professional Instructor Program
            </h1>
            <p>
              FFF President and Founder Pam M. Thompson (RDN, LDN, NHA), Sydney Bishop (RDN, LDN), and/or Olivia Tompkins,
              Director of FFF Program Development and Operations, will
              <span class="text-bold">TRAIN AND LICENSE</span> your designated health professional on a
              <span class="text-bold">FOOD SPIRAL®</span> program of your choice.
            </p>
            <p>
              We recommend this program to those associated with hospitals,
              physicians offices/clinics, dialysis centers, community centers, etc. that
              have a licensed health professional on staff and want to incorporate
              wellness into their community.
            </p>
          </div>
        </div>
        <div class="col-12 col-md-12 col-lg-12 d-flex align-items-stretch">
          <div class="card mb-3 w-100">
            <div class="card-header">
              <h4 class="card-title text-center m-0">
                Health Care Professional Instructor Program - Details
              </h4>
            </div>
            <div class="card-body">
              <p class="lead text-bold">
                FOOD SPIRAL® programs available to chose from:
              </p>
              <p>
                Healthy, Diabetes, Carb Counting, Low Sodium (hypertension), Renal
                (kidney disease), and Renal Diabetes.
              </p>
              <p class="lead text-bold">
                What’s included:
              </p>
              <ul>
                <li>
                  A 12 week PPT-based set of lesson plans and instructor scripts
                  covering various topics related to your selected
                  <span class="text-bold">FOOD SPIRAL®</span>.
                </li>
                <li>
                  1 individual monthly membership access to the website where
                  you will have access to recipes, blogs, and hundreds of different
                  resources/handouts for your audience.
                </li>
              </ul>
              <p>
                Each account is designed to meet your specific needs. Contact a Food Fitness First advisor for your free, no obligation quote today.
              </p>
            </div>
            <div class="card-footer">
              <div class="text-center mb-3">
                <button
                  type="submit"
                  class="btn btn-success btn-lg"
                  @click="openModal('healthcare')"
                >
                  Request Here
                </button>
              </div>
              <small>
                <em>
                  <p>
                    Click the ‘Request Here’ button above to submit a request form to FFF founder Pam
                    Thompson to sign up for this program.
                  </p>
                  <p>
                    *Please note: Your designated HCP MUST be knowledgeable of the
                    <span class="text-bold">FOOD SPIRAL®</span>
                    condition/topic of your choosing. Training <u>will</u> cover the education for our program,
                    but <u>not</u> of the disease (please contact us to learn more about what this entails).
                  </p>
                </em>
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Corporate -->

    <div class="container-fluid bg-white-trans py-3 mb-3 mb-sm-5">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h1 class="text-bold mb-4 text-center">
              Corporate Professional Instructor Program
            </h1>
            <p>
              FFF President and Founder Pam M. Thompson (RDN, LDN, NHA), Sydney
              Bishop (RDN, LDN), and/or Olivia Tompkins, Director of FFF Program
              Development and Operations, will
              <span
                class="text-bold"
              >TRAIN AND LICENSE</span> your designated health professional on a
              <span class="text-bold">FOOD SPIRAL®</span> program of your choice.
            </p>
            <p>
              This program is intended for corporate businesses (both small and
              large) in need of a wellness program for employees.
            </p>
          </div>
        </div>
        <div class="col-12 col-md-12 col-lg-12 d-flex align-items-stretch">
          <div class="card mb-3 w-100">
            <div class="card-header">
              <h4 class="card-title text-center m-0">
                Corporate Professional Instructor Program - Details
              </h4>
            </div>
            <div class="card-body">
              <p class="lead text-bold">
                FOOD SPIRAL® programs available to chose from:
              </p>
              <p>
                Healthy, Diabetes, Carb Counting, Low Sodium (hypertension), Renal
                (kidney disease), and Renal Diabetes.
              </p>
              <p class="lead text-bold">
                What’s included:
              </p>
              <ul>
                <li>
                  A 12 week PPT-based set of lesson plans and instructor scripts
                  covering various topics related to your selected
                  <span class="text-bold">FOOD SPIRAL®</span>.
                </li>
                <li>
                  1 individual monthly membership access to the website where
                  you will have access to recipes, blogs, and hundreds of different
                  resources/handouts for your audience.
                </li>
              </ul>
              <p>
                Each account is designed to meet your specific needs. Contact a Food Fitness First advisor for your free, no obligation quote today.
              </p>
            </div>
            <div class="card-footer">
              <div>
                <div class="text-center mb-3">
                  <button
                    type="submit"
                    class="btn btn-success btn-lg"
                    @click="openModal('corporate')"
                  >
                    Request Here
                  </button>
                </div>
              </div>
              <small>
                <em>
                  <p>
                    Click the ‘Request Here’ button above to submit a request form to FFF founder Pam Thompson to sign up for this program.
                  </p>
                  <p>
                    *Please note: Training for this program is for staff members who are NOT educated on the disease of the selected <strong>FOOD SPIRAL®</strong>, and therefore, will need more training than in the ‘Health Professional Instructor Program.‘
                  </p>
                </em>
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- School -->

    <div class="container-fluid bg-white-trans py-3 mb-3 mb-sm-5">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h1 class="text-bold mb-4 text-center">
              School Professional Instructor Program
            </h1>
            <p>
              FFF President and Founder Pam M. Thompson (RDN, LDN, NHA), Sydney Bishop (RDN, LDN), and/or Olivia Tompkins,
              Director of FFF Program Development and Operations, will
              <span class="text-bold">TRAIN AND LICENSE</span> your school staff to teach the Pediatric
              <span class="text-bold">FOOD SPIRAL®</span> program to students, parents and faculty.
            </p>
          </div>
        </div>
        <div class="col-12 col-md-12 col-lg-12 d-flex align-items-stretch">
          <div class="card mb-3 w-100">
            <div class="card-header">
              <h4 class="card-title text-center m-0">
                School Professional Instructor Program - Details
              </h4>
            </div>
            <div class="card-body">
              <p class="lead text-bold">
                What’s included:
              </p>
              <ul>
                <li>
                  Lesson plans (game and activity based), recipes, sample menus,
                  exercise lessons with sports balls (to teach healthy portion sizes),
                  individual handouts/resources on various concepts, and more -
                  tailored to age.
                </li>
                <li>
                  1 Pediatric
                  <span class="text-bold">FOOD SPIRAL®</span> book for children ages 7 to 18.
                </li>
                <li>1 paid individual membership (for access to online resources).</li>
              </ul>
              <p>
                Each account is designed to meet your specific needs. Contact a Food Fitness First advisor for your free, no obligation quote today.
              </p>
            </div>
            <div class="card-footer">
              <div>
                <div class="mb-3 text-center">
                  <button
                    type="submit"
                    class="btn btn-success btn-lg"
                    @click="openModal('school')"
                  >
                    Request Here
                  </button>
                </div>
              </div>
              <small>
                <em>
                  <p>
                    Click the ‘Request Here’ button above to submit a request form to FFF founder Pam
                    Thompson to sign up for this program.
                  </p>
                </em>
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid bg-white-trans py-3">
      <div class="container">
        <div class="row">
          <div class="col-12 text-center">
            <p>
              <em>You may NOT make copies or share Food Fitness First, Inc.® registered information with outside sources. Our program memberships are for individual purchase only. Materials are copyrighted and violators will be prosecuted.</em>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div
      v-show="modalOpen"
      ref="contactModal"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="contactModalTitle"
      aria-hidden="true"
    >
      <div
        class="modal-dialog"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5
              id="contactModalTitle"
              class="modal-title"
            >
              <span v-if="modalProgram=='healthcare'">Health Care Professional Instructor Program</span>
              <span v-if="modalProgram=='corporate'">Corporate Professional Instructor Program</span>
              <span v-if="modalProgram=='school'">School Professional Instrutor Program</span>
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <h4
              v-if="modalProgram=='healthcare'"
              class="text-center"
            >
              Send us a message about your interest in the Health Care Professional Instructor Program
            </h4>
            <h4
              v-if="modalProgram=='corporate'"
              class="text-center"
            >
              Send us a message about your interest in the Corporate Professional Instructor Program
            </h4>
            <h4
              v-if="modalProgram=='school'"
              class="text-center"
            >
              Send us a message about your interest in the School Professional Instructor Program
            </h4>
            <hr>
            <notifications />

            <form
              v-show="showForm"
              ref="form"
              @submit.prevent="sendMessage"
            >
              <div class="form-group row ">
                <label
                  for="name"
                  class="col-md-4 col-form-label text-md-right"
                >Your Name</label>
                <div class="col-md-6">
                  <input
                    id="name"
                    v-model="form.name"
                    type="text"
                    class="form-control"
                    required
                    autofocus
                    placeholder="Your Name"
                  >
                </div>
              </div>
              <div
                v-if="modalProgram=='healthcare'"
                class="form-group row "
              >
                <label
                  for="facility_name"
                  class="col-md-4 col-form-label text-md-right"
                >Your Facility's Name</label>
                <div class="col-md-6">
                  <input
                    id="facility_name"
                    v-model="form.facility_name"
                    type="text"
                    class="form-control"
                    required
                    autofocus
                    placeholder="Your Facility's Name"
                  >
                </div>
              </div>
              <div
                v-if="modalProgram=='healthcare'"
                class="form-group row "
              >
                <label
                  for="facility_address"
                  class="col-md-4 col-form-label text-md-right"
                >Your Facility's Address</label>
                <div class="col-md-6">
                  <input
                    id="facility_address"
                    v-model="form.facility_address"
                    type="text"
                    class="form-control"
                    required
                    autofocus
                    placeholder="Your Facility's Address"
                  >
                </div>
              </div>
              <div
                v-if="modalProgram=='school'"
                class="form-group row "
              >
                <label
                  for="school"
                  class="col-md-4 col-form-label text-md-right"
                >Your School</label>
                <div class="col-md-6">
                  <input
                    id="school"
                    v-model="form.school"
                    type="text"
                    class="form-control"
                    required
                    autofocus
                    placeholder="Your School"
                  >
                </div>
              </div>
              <div
                v-if="modalProgram=='school'"
                class="form-group row "
              >
                <label
                  for="school_address"
                  class="col-md-4 col-form-label text-md-right"
                >Your School's Address</label>
                <div class="col-md-6">
                  <input
                    id="school_address"
                    v-model="form.school_address"
                    type="text"
                    class="form-control"
                    required
                    autofocus
                    placeholder="Your Schools's Address"
                  >
                </div>
              </div>
              <div
                v-if="modalProgram=='corporate'"
                class="form-group row "
              >
                <label
                  for="business_name"
                  class="col-md-4 col-form-label text-md-right"
                >Name of your Business</label>
                <div class="col-md-6">
                  <input
                    id="business_name"
                    v-model="form.business_name"
                    type="text"
                    class="form-control"
                    required
                    autofocus
                    placeholder="Name of your Business"
                  >
                </div>
              </div>
              <div
                v-if="modalProgram=='corporate'"
                class="form-group row "
              >
                <label
                  for="business_address"
                  class="col-md-4 col-form-label text-md-right"
                >Your Business' Address</label>
                <div class="col-md-6">
                  <input
                    id="business_address"
                    v-model="form.business_address"
                    type="text"
                    class="form-control"
                    required
                    autofocus
                    placeholder="Your Business' Address"
                  >
                </div>
              </div>
              <div class="form-group row ">
                <label
                  for="phone"
                  class="col-md-4 col-form-label text-md-right"
                >Phone</label>
                <div class="col-md-6">
                  <input
                    id="phone"
                    v-model="form.phone"
                    type="tel"
                    class="form-control"
                    required
                    autofocus
                    placeholder="Phone"
                  >
                </div>
              </div>
              <div class="form-group row ">
                <label
                  for="email"
                  class="col-md-4 col-form-label text-md-right"
                >Email</label>
                <div class="col-md-6">
                  <input
                    id="email"
                    v-model="form.email"
                    type="text"
                    class="form-control"
                    required
                    autofocus
                    placeholder="Enter Email"
                  >
                </div>
              </div>
              <div class="form-group row">
                <label
                  for="comments"
                  class="col-md-4 col-form-label text-md-right"
                >Comments</label>
                <div class="col-md-6">
                  <textarea
                    id="comments"
                    v-model="form.comments"
                    cols="30"
                    rows="10"
                    required
                    class="form-control"
                    placeholder=""
                  />
                </div>
              </div>

              <div class="form-group row">
                <div class="col-md-6 offset-md-4">
                  <NotARobotButton v-model="form.recaptcha_response" />
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
            <button
              v-show="showForm"
              type="button"
              class="btn btn-success"
              @click="sendMessage"
            >
              Send
            </button>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Contact from "../services/contact.js";
import NotARobotButton from "../components/NotARobotButton";

export default {
  components: {
    NotARobotButton,
  },
  name: "Plans",
  data() {
    return {
      modalOpen: false,
      modalProgram: '',
      showForm: true,
      form: {},
    };
  },
  mounted() {
    $(this.$refs.contactModal).modal({
      show: false,
    });
  },
  methods: {
    sendMessage(e) {

      if (this.$refs.form.checkValidity()) {

        let formData = this.form;
        formData.program = this.modalProgram;

        this.$store.dispatch("notifications/clear");

        Contact.sendContactProfessional(formData)
          .then(res => {
            this.showForm = false;
            this.form = {};
            this.$store.dispatch("notifications/setSuccess", 'Your message was sent!');
          })
          .catch(err => {
            this.showForm = true;
            this.$store.dispatch("notifications/setError", 'There was an error processing your request.');
            this.$store.dispatch("notifications/setErrorBag", err.response.data.errors);
          });

      } else {
        this.$refs.form.reportValidity();
      }
    },
    openModal(program) {
      this.$store.dispatch("notifications/clear");

      this.showForm = true;
      this.modalProgram = program;

      $(this.$refs.contactModal).modal('show');
    },
    closeModal() {
      $(this.$refs.contactModal).modal('hide');
    }
  }
};
</script>
